import { SET_QUICK_SPECS } from '../actions/types';

export default function quickSpecs(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_QUICK_SPECS:
				return action.payload;

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/quickSpecs.js